import { Injectable } from '@angular/core'
import { LOCAL_STORAGE_KEYS } from '@shared/constants'
import { ForceAny } from '@shared/types'

@Injectable({ providedIn: 'root' })
export class LocalStorageService<LType extends LOCAL_STORAGE_KEYS = LOCAL_STORAGE_KEYS> {
  /**
   * Save data to local storage
   */
  public saveData<DType = ForceAny>(key: LType, data: DType): void {
    localStorage.setItem(key, JSON.stringify(data))
  }

  /**
   * Get data from local storage
   */
  public getData<DType = ForceAny>(key: LType): DType | undefined {
    const data = localStorage.getItem(key)
    return data ? JSON.parse(data) : undefined
  }

  /**
   * Remove data from local storage
   */
  public removeData<DType = ForceAny>(key: LType): DType | undefined {
    localStorage.removeItem(key)
    return
  }
}
